import * as React from 'react';
import { connect } from 'react-redux';
import { AdminTrendTo } from '../../components/pages/survey-admin/AdminTrendTo';
import { IApplicationState } from '../../store';
import { ActionCreators as TrendGroupActionCreators } from '../../store/TrendGroupStore';
import { UserFeatureAccessHelper } from '../../utilities/FeatureFlags';
import { AdminTrendToLoader } from '../loaders/AdminTrendToLoader';

export const AdminTrendToPageContainer = connect(
	(state: IApplicationState) => ({
		...state.trendGroup,
		isLoading: state.trendGroup.isLoadingTrendGroupId && state.trendGroup.isLoadingTrendGroups && state.trendGroup.isLoadingTrendSurveys,
		surveyAdminSummary: state.surveyAdmin.surveyAdminSummary,
		audiences: state.surveyAdmin.audiences,
		userFeatureAccessHelper: new UserFeatureAccessHelper(state.oidc.user),
	}),
	{ ...TrendGroupActionCreators },
)(AdminTrendTo);

export const AdminTrendToLoaderContainer = connect(undefined, { ...TrendGroupActionCreators })(AdminTrendToLoader);

export class AdminTrendToPage extends React.PureComponent<{ surveyId: number }> {
	public render() {
		return (
			<>
				<AdminTrendToPageContainer {...this.props} />
				<AdminTrendToLoaderContainer surveyId={this.props.surveyId} />
			</>
		);
	}
}
